import { NS_VDCP_MOBILE_WEB, NS_VDCP_WEB } from '../constants/common-enums';
import { isSDKLite } from './is-sdklite';

export const getNamespace = () => {
  return isSDKLite() ? NS_VDCP_MOBILE_WEB : NS_VDCP_WEB;
};
